export default __webpack_public_path__ + "static/media/gallery_00.e764a9a7.jpg";